(() => {
  const configNode = document.getElementById('ck-linkoo-display-titles');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const productPath = `/products/${config.handle}`;
  const titleFor = id => config.variants[String(id || config.defaultId)];
  const setText = (node, title) => {
    if (node && title && node.textContent.trim() !== title) node.textContent = title;
  };
  // StandKOO reuses this existing variant event and text updater; no navigation.
  const standkooSwitch = document.querySelector('[data-ck-standkoo-switch]');
  const standkooRoot = standkooSwitch?.closest('[data-product-root]');
  const standkooTitles = standkooRoot
    ? Array.from(standkooRoot.querySelectorAll('.product-block-title .casekoo-product-title')).map(node => ({node, original: node.textContent.trim()}))
    : [];
  const frostTitleData = standkooSwitch?.querySelector('[data-ck-frost-product]');
  const frostTitleConfig = frostTitleData ? JSON.parse(frostTitleData.textContent) : null;
  let standkooFitPending = false;
  const fitStandkooTitles = () => {
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    standkooTitles.forEach(entry => {
      const {node, original} = entry;
      const available = node.clientWidth;
      if (!available) return;
      const computed = getComputedStyle(node);
      const configured = parseFloat(computed.getPropertyValue('--casekoo-product-title-size')) || 26;
      const signature = [available, desktop, configured, computed.fontFamily, computed.fontWeight,
        computed.getPropertyValue('--casekoo-product-title-size-mobile')].join('|');
      if (entry.fitSignature === signature) return;
      // Measure both series together, without changing the visible heading.
      const measure = node.cloneNode(false);
      measure.removeAttribute('id');
      measure.setAttribute('aria-hidden', 'true');
      measure.removeAttribute('data-ck-title-wrap');
      Object.assign(measure.style, {
        position: 'absolute', visibility: 'hidden', pointerEvents: 'none',
        width: available + 'px', minHeight: '0', height: 'auto', maxHeight: 'none'
      });
      const titles = [original, frostTitleConfig?.display_title || original];
      node.parentElement.appendChild(measure);
      try {
        node.style.removeProperty('--ck-standkoo-title-fit');
        node.removeAttribute('data-ck-title-wrap');
        if (desktop) {
          measure.style.setProperty('--ck-standkoo-title-fit', configured + 'px');
          const natural = Math.max(...titles.map(title => {
            measure.textContent = title;
            return measure.scrollWidth;
          }));
          const fitted = Math.max(Math.min(configured, 20), Math.min(configured,
            configured * (available - 2) / Math.max(natural, 1)));
          const size = fitted.toFixed(2) + 'px';
          measure.style.setProperty('--ck-standkoo-title-fit', size);
          node.style.setProperty('--ck-standkoo-title-fit', size);
          const needsWrap = titles.some(title => {
            measure.textContent = title;
            return measure.scrollWidth > available;
          });
          if (needsWrap) {
            measure.setAttribute('data-ck-title-wrap', '');
            node.setAttribute('data-ck-title-wrap', '');
          }
        } else {
          measure.style.removeProperty('--ck-standkoo-title-fit');
        }
        const height = Math.max(...titles.map(title => {
          measure.textContent = title;
          return measure.getBoundingClientRect().height;
        }));
        node.style.setProperty('--ck-standkoo-title-height', Math.ceil(height) + 'px');
        entry.fitSignature = signature;
      } finally {
        measure.remove();
      }
    });
  };
  const scheduleStandkooTitleFit = () => {
    if (standkooFitPending || !standkooTitles.length) return;
    standkooFitPending = true;
    requestAnimationFrame(() => {
      standkooFitPending = false;
      fitStandkooTitles();
    });
  };
  const updateStandkooPage = detail => {
    if (!standkooRoot || detail?.productRootEl !== standkooRoot) return;
    const productId = String(detail.product?.id || '');
    if (productId === String(frostTitleConfig?.id)) {
      standkooTitles.forEach(({node}) => setText(node, frostTitleConfig.display_title));
    } else if (productId === standkooSwitch.dataset.haloProductId) {
      standkooTitles.forEach(({node, original}) => setText(node, original));
    }
    scheduleStandkooTitleFit();
  };
  const updatePage = id => {
    if (!location.pathname.endsWith(productPath)) return;
    const title = titleFor(id);
    if (title) document.title = title;
    document.querySelectorAll('.product-block-title .casekoo-product-title, [data-ck-linkoo-page-title]').forEach(node => setText(node, title));
  };
  const updateCards = () => {
    document.querySelectorAll(`a[href*="${productPath}"]`).forEach(link => {
      const url = new URL(link.getAttribute('href'), location.origin);
      const title = titleFor(url.searchParams.get('variant'));
      if (!title) return;
      const card = link.closest('.ckmc__card, .ck-product-card, .product-tile');
      if (card) {
        setText(card.querySelector('.ckmc__details h2 a, .ck-card__title, h3.font-body'), title);
        if (card.classList.contains('ckmc__card')) card.dataset.title = title;
      }
      if (!link.children.length && /LinKOO.*(?:Case|ケース)/i.test(link.textContent)) setText(link, title);
    });
  };
  document.addEventListener('theme:variant:change', event => {
    if (event.detail?.variant) updatePage(event.detail.variant.id);
    updateStandkooPage(event.detail);
  });
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      updateCards();
    });
  });
  updateCards();
  updatePage(new URL(location.href).searchParams.get('variant'));
  if (standkooSwitch?.dataset.activeSeries === 'frost') {
    updateStandkooPage({productRootEl: standkooRoot, product: {id: frostTitleConfig?.id}});
  }
  if (standkooTitles.length) {
    // Observe width only; changing title height must not create resize loops.
    const widths = new WeakMap();
    const titleResize = new ResizeObserver(entries => {
      if (entries.some(entry => {
        const width = entry.contentRect.width;
        const changed = widths.get(entry.target) !== width;
        widths.set(entry.target, width);
        return changed;
      })) scheduleStandkooTitleFit();
    });
    standkooTitles.forEach(({node}) => titleResize.observe(node.parentElement));
    scheduleStandkooTitleFit();
    document.fonts?.ready.then(() => {
      standkooTitles.forEach(entry => { entry.fitSignature = null; });
      scheduleStandkooTitleFit();
    });
  }
  observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
})();

